//export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
//export const API_URL = 'http://localhost:3000';
//export const API_URL = window.location.protocol + '//Languageappbackend-dev5.eba-kkq7qxcc.us-east-2.elasticbeanstalk.com';
//export const API_URL = 'http://Languageappbackend-dev5.eba-kkq7qxcc.us-east-2.elasticbeanstalk.com';

console.log("🔍 src/config.js is being loaded and executed");
// Get API URL from window.APP_CONFIG first if available, then fallback to env vars
export const getApiUrl = () => {
    // First check window.APP_CONFIG (from our build-time generated config)
    if (window.APP_CONFIG && window.APP_CONFIG.API_URL) {
      console.log('Using API URL from APP_CONFIG:', window.APP_CONFIG.API_URL);
      return window.APP_CONFIG.API_URL;
    }
    
    // Fall back to environment variables if APP_CONFIG isn't available
    if (process.env.REACT_APP_API_URL) {
      console.log('Using API URL from REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
      return process.env.REACT_APP_API_URL;
    }
    
    // Default fallback
    console.log('Using default API URL: http://localhost:8000');
    return 'http://localhost:8000';
  };
  
  // Export the API_URL 
  export const API_URL = getApiUrl();
  
  // Log for debugging
  console.log('Final API_URL being used:', API_URL);